import { Rows } from "../../components/Rows";
import { ExternalButton } from "../../components/Button";
import { useConfig } from "../../hooks/useConfig";
import { GRADUATION, LAUNCH_FEE, PAIR_FALLBACK } from "../../lib/facts";
import { creatorShare, tradersPay } from "../../lib/fees";

/**
 * The paired asset is chosen once on the Pons v2 create form and is fixed for
 * the life of the launch. $TISM is paired with ETH.
 */
export function PairedWithEth() {
  const { config } = useConfig();
  const pair = config?.pair.symbol ?? PAIR_FALLBACK;
  const graduated = config?.launch?.graduated ?? false;
  const graduatedAt = config?.launch?.graduatedAt ?? null;

  return (
    <section className="shell section section--ruled" id="paired-with-eth">
      <div className="split">
        <div className="stack stack-3">
          <p className="eyebrow">Paired with {pair}</p>
          <h2>You buy and sell $TISM in {pair}.</h2>
        </div>
        <div className="stack stack-5">
          <p className="body">
            Pons launches pick one paired asset and keep it forever. $TISM is paired with {pair}. So
            the price of $TISM is quoted in {pair}, buyers spend {pair}, and sellers receive {pair}.
            Gas on Robinhood Chain is paid in ETH too.
          </p>
          <div className="card">
            <Rows
              items={[
                { key: "pair", label: "Paired asset", value: pair },
                { key: "launch", label: "Launch fee", value: LAUNCH_FEE },
                graduated
                  ? { key: "grad", label: "Graduated", value: `${graduatedAt ?? "yes"}, after the curve raised ${GRADUATION}` }
                  : { key: "grad", label: "Graduates once the curve has raised", value: GRADUATION },
                { key: "fee", label: "Trading fee", value: tradersPay(config) },
                { key: "creator", label: "Creator's share", value: creatorShare(config) },
                {
                  key: "grad-pool",
                  label: graduated ? "Liquidity" : "At graduation",
                  value: graduated
                    ? `Locked permanently in a Uniswap v4 TISM/${pair} pool`
                    : `Liquidity moves to a Uniswap v4 TISM/${pair} pool and is locked permanently`,
                },
                {
                  key: "after",
                  label: "After launch",
                  value: "No mint, no freeze, no blacklist, no fee change",
                },
              ]}
            />
          </div>
          {graduated ? (
            <p className="body">
              The bonding curve raised {GRADUATION} and closed{graduatedAt ? ` on ${graduatedAt}` : ""}. Trading
              now happens on a Uniswap v4 pool that trades TISM with {pair}, and that liquidity is
              locked permanently. The Pons listing routes to the same pool.
            </p>
          ) : (
            <p className="body">
              Until graduation, trades happen on the bonding curve. Once the curve has raised{" "}
              {GRADUATION}, the launchpad moves the liquidity into a Uniswap v4 pool that trades TISM
              with {pair}, and that liquidity is locked permanently.
            </p>
          )}
          {config?.ponsUrl ? (
            <ExternalButton href={config.ponsUrl} variant="ghost">
              Open the Pons listing
            </ExternalButton>
          ) : (
            <p className="tiny">
              The Pons listing link appears here once the launch is live. This page reads it from
              the server, so it appears as soon as the launch is live.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
